import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import axios from "axios";
import consts from "../../constant";

const url = `${consts.BackendUrl}`;

interface singleCoin {
    currencyId: string;
    currency: string;
    type: string,
}

interface withdraw {
    currency: string;
    amount: number;
    address: string;
}


export const getWalletList = createAsyncThunk(
    "profile/getWalltes", // ✅ Unique action type under "profile"
    async ({ }: any, { rejectWithValue }) => {
        try {
            const response = await axios.get(`${url}/wallet/getWallets`, {
                // withCredentials: true,
                headers: {
                    "Content-Type": "application/json",
                    "Authorization": `Bearer ${localStorage.getItem('crymadx')}`
                }
            });
            return response?.data;
        } catch (error) {
            if (axios.isAxiosError(error) && error.response) {
                return rejectWithValue(error.response.data?.message || "Wallets List Get failed!");
            }
            return rejectWithValue("Deposit Address Genarate failed!");
        }
    }
);



export const createWallets = createAsyncThunk(
    "profile/createWallets", // ✅ Unique action type under "profile"
    async (formData: singleCoin, { rejectWithValue }) => {
        try {
            const response = await axios.post(`${url}/wallet/createwallet`, formData, {
                // withCredentials: true,
                headers: {
                    "Content-Type": "application/json",
                    "Authorization": `Bearer ${localStorage.getItem('crymadx')}`
                }
            });
            return response?.data;
        } catch (error) {
            if (axios.isAxiosError(error) && error.response) {
                return rejectWithValue(error.response.data || "Deposit Address Genarate failed!");
            }
            return rejectWithValue("Deposit Address Genarate failed!");
        }
    }
);


export const getPairBalance = createAsyncThunk(
    "profile/getPairBalance",
    async (formData: any, { rejectWithValue }) => {
        try {
            const response = await axios.post(`${url}/wallet/getPairBalance`, formData, {
                // withCredentials: true,
                headers: {
                    "Content-Type": "application/json",
                    "Authorization": `Bearer ${localStorage.getItem('crymadx')}`
                }
            });
            return response?.data;
        } catch (error) {
            if (axios.isAxiosError(error) && error.response) {
                return rejectWithValue(error.response.data || "Get Pair Balance failed!");
            }
            return rejectWithValue("Get Pair Balance failed!");
        }
    }
);


export const getWithdrawRequest = createAsyncThunk(
    "wallet/getWithdrawRequest", // ✅ Unique action type under "profile"
    async (formData: withdraw, { rejectWithValue }) => {
        try {
            const response = await axios.post(`${url}/wallet/getWithdrawRequest`, formData, {
                // withCredentials: true,
                headers: {
                    "Content-Type": "application/json",
                    "Authorization": `Bearer ${localStorage.getItem('crymadx')}`
                }
            });
            return response?.data;
        } catch (error) {
            if (axios.isAxiosError(error) && error.response) {
                return rejectWithValue(error.response.data || "Withdraw Request Genarate failed!");
            }
            return rejectWithValue("Withdraw Request Genarate failed!");
        }
    }
);


export const getNotification = createAsyncThunk(
    "wallet/getNotification", // ✅ Unique action type under "profile"
    async (_, { rejectWithValue }) => {
        try {
            const response = await axios.get(`${url}/wallet/getNotification`, {
                // withCredentials: true,
                headers: {
                    "Content-Type": "application/json",
                    "Authorization": `Bearer ${localStorage.getItem('crymadx')}`
                }
            });
            return response?.data;
        } catch (error) {
            if (axios.isAxiosError(error) && error.response) {
                return rejectWithValue(error.response.data || " Notification Fetch  failed!");
            }
            return rejectWithValue(" Notification Fetch  failed !");
        }
    }
)

export const setNotificationSeen = createAsyncThunk(
    "wallet/setNotificationSeen", // ✅ Unique action type under "Notification"
    async (payload: any, { rejectWithValue }) => {
        try {
            const response = await axios.post(`${url}/wallet/setNotificationSeen`, payload, {
                // withCredentials: true,
                headers: {
                    "Content-Type": "application/json",
                    "Authorization": `Bearer ${localStorage.getItem('crymadx')}`
                }
            });
            return response?.data;
        } catch (error) {
            if (axios.isAxiosError(error) && error.response) {
                return rejectWithValue(error.response.data || " Notification seen failed!");
            }
            return rejectWithValue(" Notification seen failed !");
        }
    }
);



const walletSlice = createSlice({
    name: "wallets",
    initialState: {
        wallet: null,
        deposit: null,
        isLoading: false,
        pairBlance: null,
        error: null,
        notification: null
    },
    reducers: {},
    extraReducers: (builder) => {
        builder
            .addCase(getWalletList.pending, (state) => {
                state.isLoading = true;
            })
            .addCase(getWalletList.fulfilled, (state, action) => {
                state.isLoading = false;
                state.wallet = action.payload;
            })
            .addCase(getWalletList.rejected, (state, action) => {
                state.isLoading = false;
                state.error = action.payload as any;
            })
            .addCase(createWallets.pending, (state) => {
                state.isLoading = true;
            })
            .addCase(createWallets.fulfilled, (state, action) => {
                state.isLoading = false;
                state.deposit = action.payload;

            })
            .addCase(createWallets.rejected, (state, action) => {
                state.isLoading = false;
                state.error = action.payload as any;
            })

            .addCase(getPairBalance.pending, (state) => {
                state.isLoading = true;
            })
            .addCase(getPairBalance.fulfilled, (state, action) => {
                state.isLoading = false;
                state.pairBlance = action.payload;

            })
            .addCase(getPairBalance.rejected, (state, action) => {
                state.isLoading = false;
                state.error = action.payload as any;
            })

            .addCase(getNotification.pending, (state) => {
                state.isLoading = true;
            })
            .addCase(getNotification.fulfilled, (state, action) => {
                state.isLoading = false;
                state.notification = action.payload;

            })
            .addCase(getNotification.rejected, (state, action) => {
                state.isLoading = false;
                state.error = action.payload as any;
            })
    },
});


export default walletSlice.reducer;
